import React from 'react';

/**
 * @param {string} key - Translation key
 * @param {Record<string, string | number>} [_vars] - Optional placeholders for {{ key }} substitution
 * @returns {string}
 */
function defaultTranslator(key, _vars) {
	return key;
}

const TranslationsContext = React.createContext(defaultTranslator);

export default TranslationsContext;
